interface ISearchResult {
  username: string;
  gameName: string;
  roomId: number;
  roomName: string;
}

class SearchResult implements ISearchResult {
  constructor(public username: string, public gameName: string, public roomId: number, public roomName: string) {
  }

  public equals(searchResult: SearchResult): boolean {
    if (!searchResult) {
      return false;
    }

    if (!this.areStringsEqual(this.username, searchResult.username)) {
      return false;
    }

    if (!this.areStringsEqual(this.gameName, searchResult.gameName)) {
      return false;
    }

    if (this.roomId !== searchResult.roomId) {
      return false;
    }

    if (!this.areStringsEqual(this.roomName, searchResult.roomName)) {
      return false;
    }

    return true;
  }

  private areStringsEqual(stringA: string, stringB: string): boolean {
    const compareStringA = (stringA || '').toLowerCase();
    const compareStringB = (stringB || '').toLowerCase();
    return compareStringA.localeCompare(compareStringB) === 0;
  }
}

export { ISearchResult, SearchResult };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/search-bar/_domain/models/search-result-model.ts